<template>
  <div :class="[{ 'no-wrap': nowrap }, textSizeClass]" class="wrapper">
    <section :class="textColorClass">
      <span v-if="period.start_date" :class="textWeightClass" class="label">
        {{ period.start_date }}
      </span>
      <span
        v-if="period.start_weekday && showWeekday"
        :class="[textWeightClass ? textWeightClass : 'font-medium']"
        class="label">
        {{ period.start_weekday }}
      </span>
      <span v-if="period.start_time" class="label">
        {{ period.start_time }}
      </span>
    </section>
    <span v-if="showEndPeriod" class="mx-1 text-gray-500">
      {{ $breakpoints.sm ? '-' : '－' }}
    </span>
    <section v-if="showEndPeriod" :class="textColorClass">
      <span
        v-if="showEndDate(period.start_date, period.end_date)"
        :class="[textWeightClass ? textWeightClass : 'font-medium']"
        class="label"
      >
        {{ period.end_date }}
      </span>
      <span
        v-if="
          showEndDate(period.start_date, period.end_date)
          && period.end_weekday
          && showWeekday
        "
        :class="textWeightClass"
        class="label"
      >
        {{ period.end_weekday }}
      </span>
      <span v-if="period.end_time" class="label">
        {{ period.end_time }}
      </span>
    </section>
  </div>
</template>

<script>
import DisplayedTimeFormat from './DisplayedTimeFormat';

export default DisplayedTimeFormat;
</script>

<style lang="scss" scoped>
@import 'DisplayedTimeFormat';
</style>
